import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './crypto_v2/Header';
import Footer from './crypto_v2/Footer';
import Home from './crypto_v2/Home';
import Tape from './crypto_v2/Tape';
import Thesis from './crypto_v2/Thesis';
import Access from './crypto_v2/Access';

export default function CryptoTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#14110F]" data-testid="aem-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }} data-testid={`aem-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'tape' && <Tape setPage={setPage} />}
          {page === 'thesis' && <Thesis setPage={setPage} />}
          {page === 'access' && <Access setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
